const _regex = /\${([^}]+)}/g;

type FormatValue = string | number;
type LookUpFunction = (id: string) => FormatValues;
type LookUpDict = Record<string | number, FormatValue>;
export type FormatValues = FormatValue | LookUpDict | LookUpFunction | FormatValue[];

export function format(text: string, v: FormatValues | undefined, options?: { regex?: RegExp }): string {
  if (!v)
    return text;

  const regex = options?.regex || _regex;

  if (typeof v === "function")
    return formatByFunction(text, v, regex);
  else if (Array.isArray(v)) {
    return formatByArray(text, v, regex);
  } else if (typeof v === "string" || typeof v === "number") {
    return formatByArray(text, [v], regex);
  }

  return formatByDict(text, v, regex);
}

function formatByDict(text: string, dict: LookUpDict, regex: RegExp): string {
  const result = text.replace(regex, (split, ..._args) => { // replace all not supported on server
    const id = calcIdFromSplit(split);
    if (id in dict)
      return (dict as any)[id].toString();
    return split;
  })
  return result;
}

function formatByArray(text: string, values: FormatValue[], regex: RegExp): string {
  const result = text.replace(regex, (split, ..._args) => {
    const id = calcIdFromSplit(split);
    if (id) {
      const index = +id;
      if (index >= 0 && index < values.length)
        return values[index].toString();
    }
    return split;
  })
  return result;
}

function formatByFunction(text: string, fn: LookUpFunction, regex: RegExp): string {
  const result = text.replace(regex, (split, ..._args) => {
    const id = calcIdFromSplit(split)
    return fn(id).toString();
  })
  return result;
}

function calcIdFromSplit(split: string): string {
  const id = split.substring(2, split.length - 1);
  return id;
}